import React, { Component } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Checkbox } from 'primereact/checkbox';
import { Toast } from 'primereact/toast';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toolbar } from 'primereact/toolbar';
import { BreadCrumb } from 'primereact/breadcrumb';
import { TabMenu } from 'primereact/tabmenu';
import Service from '../../services';
import { baseUrlAdmin, primaryColor } from '../../store/apiConstants';
import Authentication from '../session';
import Authorizer, { PERMISSIONS } from '../session/authorizer';
import { connect } from 'react-redux';
import withRouter from '../lib/withRouter';
import PromotionModuleSelection from './PromotionModuleSelection';
import PromotionPreview from './PromotionPreview';
import './Promotions.css';
import { BoardsIconActive, BoardsIconInActive, BranchTowersIcon, GradesIcon, SectionIcon } from '../svgIcons';
import ClassetDropdown from '../../classetComponents/classetDropDown';
import { removeDuplicates } from '../../utils/arrayHelpers';

const items = [
    { label: 'Academics' },
    { label: 'Promotions', className: 'ma-active-item' }
];

const home = { icon: 'pi pi-home' };

class Promotions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedAcademicYear: '',
            academicYearOptions: [],
            branchData: [],
            boardData: [],
            gradeData: [],
            sectionData: [],
            isLoading: false,
            isDataLoading: false,
            currentTab: 0,
            // Store selections for each branch
            branchSelections: {}, // { branchId: { boards: [], grades: [], sections: [] } }
            selectedBranch: null, // Currently active branch for viewing
            selectedBoard: null, // Currently active board for viewing
            selectedGrade: null, // Currently active grade for viewing
            allBranchData: [], // Store complete branch data with nested structure
            alreadyPromotedData: null, // Store fetched promotion data
            alreadyPromotedSectionIds: [], // Array of section IDs that are already promoted
            promotionData: null // Store promotion data for navigation between screens
        };
        this.service = new Service();
        this.toast = React.createRef();
    }

    // Add these missing methods
    showError = (message) => {
        if (this.toast.current) {
            this.toast.current.show({
                severity: 'error',
                summary: 'Error',
                detail: message,
                life: 3000
            });
        }
    }

    showSuccess = (message) => {
        if (this.toast.current) {
            this.toast.current.show({
                severity: 'success',
                summary: 'Success',
                detail: message,
                life: 1000
            });
        }
    }

    showWarn = (message) => {
        if (this.toast.current) {
            this.toast.current.show({
                severity: 'warn',
                summary: 'Warning',
                detail: message,
                life: 3000
            });
        }
    }

    validateSelection = (selectedData) => {
        if (!selectedData.selectedBranches || selectedData.selectedBranches.length === 0) {
            this.showError('Please select at least one branch');
            return false;
        }

        if (!selectedData.selectedSections || selectedData.selectedSections.length === 0) {
            this.showError('Please select at least one section for promotion');
            return false;
        }

        if (!selectedData.academicYear) {
            this.showError('Please select target academic year');
            return false;
        }

        return true;
    }

    componentDidMount() {
        this.loadAcademicYears();
        this.loadCurrentAcademicYearBranches();
    }

    onTabChange = (currentTab) => {
        this.setState({ currentTab });
    }

    // rightToolbarTemplate = () => {
    //     return (
    //         <React.Fragment>
    //             <h4 className='ma-tab-title'>Student Promotions</h4>
    //         </React.Fragment>
    //     );
    // }

    leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <BreadCrumb model={items} home={home} />
            </React.Fragment>
        );
    }

    loadAcademicYears = () => {
        this.setState({ isLoading: true });
        const userAcademicYear = localStorage.getItem('userAcademicYear');
        const url = `${baseUrlAdmin}/promotions/academic-years?currentAcademicYear=${userAcademicYear}`;

        this.service.get(url, true)
            .then((response) => {
                if (response.status && response.res?.data) {
                    this.setState({
                        academicYearOptions: response.res.data,
                        isLoading: false
                    });
                } else {
                    this.setState({ isLoading: false });
                    this.showError('Failed to load academic years');
                }
            })
            .catch((error) => {
                console.error('Error loading academic years:', error);
                this.setState({ isLoading: false });
                this.showError('Error loading academic years');
            });
    }

    loadCurrentAcademicYearBranches = () => {
        this.setState({ isDataLoading: true });

        const currentAcademicYear = localStorage.getItem('userAcademicYear');

        if (!currentAcademicYear) {
            this.setState({ isDataLoading: false });
            this.showError('Current academic year not found');
            return;
        }

        const url = `${baseUrlAdmin}/promotions/branch-to-sections?academicYear=${currentAcademicYear}`;

        this.service.get(url, true)
            .then((response) => {
                if (response.status && response.res?.data) {
                    const data = response.res.data;
                    this.processPromotionData(data);
                    this.setState({ isDataLoading: false });
                } else {
                    this.setState({ isDataLoading: false });
                    this.showError('Failed to load branch data');
                }
            })
            .catch((error) => {
                console.error('Error loading branch data:', error);
                this.setState({ isDataLoading: false });
                this.showError('Error loading branch data');
            });
    }

    processPromotionData = (data) => {
        const branchData = data.branches || [];

        // Deduplicate boards in each branch and calculate correct board count
        const processedBranchData = branchData.map(branch => {
            if (branch.boards && Array.isArray(branch.boards)) {
                const uniqueBoards = removeDuplicates(branch.boards, 'boardId');
                return {
                    ...branch,
                    boards: uniqueBoards,
                    boardCount: uniqueBoards.length,
                    selected: false
                };
            }
            return { ...branch, selected: false };
        });

        this.setState({
            branchData: processedBranchData,
            allBranchData: processedBranchData, // Store complete data with deduplicated boards
            boardData: [],
            gradeData: [],
            sectionData: [],
            branchSelections: {},
            selectedBranch: null
        });
    }

    onAcademicYearChange = (academicYear) => {
        this.setState({
            selectedAcademicYear: academicYear,
            boardData: [],
            gradeData: [],
            sectionData: []
        });


        const resetBranchData = this.state.branchData.map(branch => ({ ...branch, selected: false }));
        this.setState({ branchData: resetBranchData });

        // Automatically fetch branch-to-sections data when academic year is selected
        if (academicYear) {
            this.fetchBranchToSectionsData(academicYear);
        }
    }

    onBranchChange = (branchId, checked) => {
        // Check if academic year is selected first
        if (!this.state.selectedAcademicYear) {
            this.showWarn('Please select Target Academic Year first before selecting branches');
            return;
        }

        const updatedBranchData = this.state.branchData.map(branch => {
            if (branch.branchId === branchId) {
                return { ...branch, selected: checked };
            }
            return branch;
        });

        // Initialize branch selections if not exists
        const branchSelections = { ...this.state.branchSelections };
        if (!branchSelections[branchId]) {
            branchSelections[branchId] = {
                boards: [],
                grades: [],
                sections: []
            };
        }

        // If unchecking, clear selections for this branch and show warning
        if (!checked) {
            const hadSelections = branchSelections[branchId].boards.length > 0 ||
                branchSelections[branchId].grades.length > 0 ||
                branchSelections[branchId].sections.length > 0;

            branchSelections[branchId] = {
                boards: [],
                grades: [],
                sections: []
            };

            if (hadSelections) {
                this.showError('Branch deselected. All related board, grade, and section selections have been cleared.');
            }

            // Also clear the view data if this branch was currently selected
            if (this.state.selectedBranch === branchId) {
                this.setState({
                    boardData: this.state.boardData.map(board => ({ ...board, selected: false })),
                    gradeData: this.state.gradeData.map(grade => ({ ...grade, selected: false })),
                    sectionData: this.state.sectionData.map(section => ({ ...section, selected: false }))
                });
            }
        }

        this.setState({
            branchData: updatedBranchData,
            branchSelections
        });

        // If this is the currently selected branch, update the view
        if (this.state.selectedBranch === branchId) {
            this.loadBranchSpecificData(branchId);
        }
    }

    // New method to handle branch click for viewing
    onBranchClick = (branchId) => {
        if (this.state.selectedBranch === branchId) return; // Already selected

        this.setState({
            selectedBranch: branchId,
            selectedBoard: null,
            selectedGrade: null
        });
        this.loadBranchSpecificData(branchId);
    }

    loadBranchSpecificData = (branchId) => {
        const branch = this.state.allBranchData.find(b => b.branchId === branchId);
        if (!branch) return;

        const branchSelections = this.state.branchSelections[branchId] || {
            boards: [],
            grades: [],
            sections: []
        };

        // Load boards for this branch and deduplicate (safety check)
        const uniqueBoards = branch.boards ? removeDuplicates(branch.boards, 'boardId') : [];
        const boardsData = uniqueBoards.map(board => ({
            ...board,
            selected: branchSelections.boards.some(sb => sb.boardId === board.boardId)
        }));

        this.setState({
            boardData: boardsData,
            gradeData: [],
            sectionData: []
        });

        // If there are selected boards, load their grades
        const selectedBoards = branchSelections.boards;
        if (selectedBoards.length > 0) {
            this.loadGradesForSelectedBoards(branch, selectedBoards, branchSelections);
        }
    }

    loadGradesForSelectedBoards = (branch, selectedBoards, branchSelections) => {
        const gradesMap = new Map();

        branch.boards?.forEach(board => {
            const isSelectedBoard = selectedBoards.some(sb => sb.boardId === board.boardId);
            if (isSelectedBoard) {
                board.grades?.forEach(grade => {
                    const key = `${grade.gradeId}`;
                    if (!gradesMap.has(key)) {
                        gradesMap.set(key, {
                            ...grade,
                            selected: branchSelections.grades.some(sg => sg.gradeId === grade.gradeId)
                        });
                    }
                });
            }
        });

        const gradeData = Array.from(gradesMap.values());
        this.setState({ gradeData });

        // If there are selected grades, load their sections
        const selectedGrades = branchSelections.grades;
        if (selectedGrades.length > 0) {
            this.loadSectionsForSelectedGrades(gradeData, selectedGrades, branchSelections);
        }
    }

    loadSectionsForSelectedGrades = (gradeData, selectedGrades, branchSelections) => {
        const sectionsArray = [];
        const alreadyPromotedSectionIds = this.state.alreadyPromotedSectionIds || [];

        gradeData.forEach(grade => {
            const isSelectedGrade = selectedGrades.some(sg => sg.gradeId === grade.gradeId);
            if (isSelectedGrade) {
                grade.sections?.forEach(section => {
                    const isAlreadyPromoted = alreadyPromotedSectionIds.includes(section.sectionId);
                    sectionsArray.push({
                        ...section,
                        selected: isAlreadyPromoted ? false : branchSelections.sections.some(ss => ss.sectionId === section.sectionId),
                        isAlreadyPromoted: isAlreadyPromoted,
                        disabled: isAlreadyPromoted
                    });
                });
            }
        });

        this.setState({ sectionData: sectionsArray });
    }

    onBoardChange = (boardId, checked) => {
        // Check if academic year is selected first
        if (!this.state.selectedAcademicYear) {
            this.showWarn('Please select Target Academic Year first before selecting boards');
            return;
        }

        if (!this.state.selectedBranch) return;

        // Check if current branch is selected
        const currentBranch = this.state.branchData.find(b => b.branchId === this.state.selectedBranch);
        if (!currentBranch?.selected) {
            this.showError('Please select the branch first before selecting boards');
            return;
        }

        const updatedBoardData = this.state.boardData.map(board => {
            if (board.boardId === boardId) {
                return { ...board, selected: checked };
            }
            return board;
        });

        // Update branch selections
        const branchSelections = { ...this.state.branchSelections };
        const currentBranchId = this.state.selectedBranch;

        if (!branchSelections[currentBranchId]) {
            branchSelections[currentBranchId] = { boards: [], grades: [], sections: [] };
        }

        if (checked) {
            // Add board to selections
            const board = this.state.boardData.find(b => b.boardId === boardId);
            if (board && !branchSelections[currentBranchId].boards.some(b => b.boardId === boardId)) {
                branchSelections[currentBranchId].boards.push({
                    boardId: board.boardId,
                    boardName: board.boardName
                });
            }
        } else {
            // Remove board and its related grades/sections
            branchSelections[currentBranchId].boards = branchSelections[currentBranchId].boards.filter(b => b.boardId !== boardId);

            // Remove grades that belong to this board
            const branch = this.state.allBranchData.find(br => br.branchId === currentBranchId);
            const board = branch?.boards?.find(b => b.boardId === boardId);

            branchSelections[currentBranchId].grades = branchSelections[currentBranchId].grades.filter(g => {
                return !board?.grades?.some(grade => grade.gradeId === g.gradeId);
            });

            // Remove sections that belong to grades of this board
            branchSelections[currentBranchId].sections = branchSelections[currentBranchId].sections.filter(s => {
                let shouldKeep = true;
                board?.grades?.forEach(grade => {
                    if (grade.sections?.some(section => section.sectionId === s.sectionId)) {
                        shouldKeep = false;
                    }
                });
                return shouldKeep;
            });

            // If this board was currently selected for viewing, clear the grade/section view
            if (this.state.selectedBoard === boardId) {
                this.setState({
                    gradeData: [],
                    sectionData: [],
                    selectedBoard: null,
                    selectedGrade: null
                });
            }
        }

        this.setState({
            boardData: updatedBoardData,
            branchSelections
        });

        // Update grade data based on currently selected boards
        this.updateGradeDataForSelectedBoards();
    }

    // New method to update grade data based on selected boards
    updateGradeDataForSelectedBoards = () => {
        if (!this.state.selectedBranch) return;

        const currentBranchId = this.state.selectedBranch;
        const branchSelections = this.state.branchSelections[currentBranchId] || { boards: [], grades: [], sections: [] };
        const selectedBoards = branchSelections.boards;

        if (selectedBoards.length === 0) {
            // No boards selected, clear grade and section data
            this.setState({
                gradeData: [],
                sectionData: [],
                selectedBoard: null,
                selectedGrade: null
            });
            return;
        }

        // If there's a currently selected board for viewing, update its data
        if (this.state.selectedBoard) {
            const isCurrentBoardStillSelected = selectedBoards.some(sb => sb.boardId === this.state.selectedBoard);
            if (isCurrentBoardStillSelected) {
                this.loadBoardSpecificData(this.state.selectedBoard);
            } else {
                // Current board is no longer selected, clear the view
                this.setState({
                    gradeData: [],
                    sectionData: [],
                    selectedBoard: null,
                    selectedGrade: null
                });
            }
        }
    }

    onGradeChange = (gradeId, checked) => {
        // Check if academic year is selected first
        if (!this.state.selectedAcademicYear) {
            this.showWarn('Please select Target Academic Year first before selecting grades');
            return;
        }

        if (!this.state.selectedBranch) return;

        // Check if current branch is selected
        const currentBranch = this.state.branchData.find(b => b.branchId === this.state.selectedBranch);
        if (!currentBranch?.selected) {
            this.showError('Please select the branch first before selecting grades');
            return;
        }

        // Check if any board is selected for this grade
        const currentBranchId = this.state.selectedBranch;
        const branchSelections = this.state.branchSelections[currentBranchId] || { boards: [], grades: [], sections: [] };

        // Find which board this grade belongs to
        const branch = this.state.allBranchData.find(br => br.branchId === currentBranchId);
        let belongsToSelectedBoard = false;

        if (branch?.boards) {
            for (const board of branch.boards) {
                if (board.grades?.some(g => g.gradeId === gradeId)) {
                    // Check if this board is selected
                    if (branchSelections.boards.some(sb => sb.boardId === board.boardId)) {
                        belongsToSelectedBoard = true;
                        break;
                    }
                }
            }
        }

        if (!belongsToSelectedBoard) {
            this.showError('Please select the corresponding board first before selecting grades');
            return;
        }

        const updatedGradeData = this.state.gradeData.map(grade => {
            if (grade.gradeId === gradeId) {
                return { ...grade, selected: checked };
            }
            return grade;
        });

        const updatedBranchSelections = { ...this.state.branchSelections };

        if (checked) {
            // Add grade to selections
            const grade = this.state.gradeData.find(g => g.gradeId === gradeId);
            if (grade && !branchSelections.grades.some(g => g.gradeId === gradeId)) {
                branchSelections.grades.push({
                    gradeId: grade.gradeId,
                    gradeName: grade.gradeName
                });
            }
        } else {
            // Remove grade and its sections
            branchSelections.grades = branchSelections.grades.filter(g => g.gradeId !== gradeId);
            branchSelections.sections = branchSelections.sections.filter(s => {
                const grade = this.state.gradeData.find(g => g.gradeId === gradeId);
                return !grade?.sections?.some(section => section.sectionId === s.sectionId);
            });
        }

        updatedBranchSelections[currentBranchId] = branchSelections;

        this.setState({
            gradeData: updatedGradeData,
            branchSelections: updatedBranchSelections,
            // When a grade is selected, automatically set it as the selectedGrade to show its sections
            selectedGrade: checked ? gradeId : null
        });

        // If grade is checked, load sections only for this specific grade
        if (checked) {
            this.loadGradeSpecificData(gradeId);
        } else {
            // If unchecked and it was the selected grade, clear sections
            if (this.state.selectedGrade === gradeId) {
                this.setState({ sectionData: [], selectedGrade: null });
            }
        }
    }

    updateSectionDataForCurrentBranch = (gradeData = this.state.gradeData) => {
        if (!this.state.selectedBranch) return;

        const selectedGrades = gradeData.filter(grade => grade.selected);
        const currentBranchId = this.state.selectedBranch;
        const branchSelections = this.state.branchSelections[currentBranchId] || { boards: [], grades: [], sections: [] };

        if (selectedGrades.length === 0) {
            this.setState({ sectionData: [] });
            return;
        }

        this.loadSectionsForSelectedGrades(gradeData, branchSelections.grades, branchSelections);
    }

    onSectionChange = (sectionId, checked) => {
        if (!this.state.selectedBranch) return;

        // Check if section is already promoted
        const section = this.state.sectionData.find(s => s.sectionId === sectionId);
        if (section?.isAlreadyPromoted) {
            this.showError('This section has already been promoted and cannot be selected again');
            return;
        }

        // Check if current branch is selected
        const currentBranch = this.state.branchData.find(b => b.branchId === this.state.selectedBranch);
        if (!currentBranch?.selected) {
            this.showError('Please select the branch first before selecting sections');
            return;
        }

        // Find which grade this section belongs to and check if it's selected
        const currentBranchId = this.state.selectedBranch;
        const branchSelections = this.state.branchSelections[currentBranchId] || { boards: [], grades: [], sections: [] };

        // Find the grade for this section
        let belongsToSelectedGrade = false;
        const branch = this.state.allBranchData.find(br => br.branchId === currentBranchId);

        if (branch?.boards) {
            for (const board of branch.boards) {
                if (board.grades) {
                    for (const grade of board.grades) {
                        if (grade.sections?.some(s => s.sectionId === sectionId)) {
                            // Check if this grade is selected
                            if (branchSelections.grades.some(sg => sg.gradeId === grade.gradeId)) {
                                belongsToSelectedGrade = true;
                                break;
                            }
                        }
                    }
                }
                if (belongsToSelectedGrade) break;
            }
        }

        if (!belongsToSelectedGrade) {
            this.showError('Please select the corresponding grade first before selecting sections');
            return;
        }

        const updatedSectionData = this.state.sectionData.map(section => {
            if (section.sectionId === sectionId) {
                return { ...section, selected: checked };
            }
            return section;
        });

        const updatedBranchSelections = { ...this.state.branchSelections };

        if (checked) {
            // Add section to selections
            const section = this.state.sectionData.find(s => s.sectionId === sectionId);
            if (section && !branchSelections.sections.some(s => s.sectionId === sectionId)) {
                branchSelections.sections.push({
                    sectionId: section.sectionId,
                    sectionName: section.sectionName,
                    studentCount: section.studentCount,
                    gradeId: section.gradeId,
                    gradeName: section.gradeName
                });
            }
        } else {
            // Remove section
            branchSelections.sections = branchSelections.sections.filter(s => s.sectionId !== sectionId);
        }

        updatedBranchSelections[currentBranchId] = branchSelections;

        this.setState({
            sectionData: updatedSectionData,
            branchSelections: updatedBranchSelections
        });
    }
    //////////////////////
    // Updated methods
    getSelectedData = () => {
        const allSelectedSections = [];
        const allSelectedBranches = [];
        const allSelectedBoards = [];
        const allSelectedGrades = [];

        // Collect all selections from all branches
        Object.keys(this.state.branchSelections).forEach(branchId => {
            const branchSelection = this.state.branchSelections[branchId];
            const branch = this.state.branchData.find(b => b.branchId === branchId);

            if (branch && branch.selected) {
                allSelectedBranches.push({
                    branchId: branch.branchId,
                    branchName: branch.branchName
                });

                // Collect all boards
                allSelectedBoards.push(...branchSelection.boards);

                // Collect all grades
                allSelectedGrades.push(...branchSelection.grades);

                // Add all sections with branch context
                branchSelection.sections.forEach(section => {
                    allSelectedSections.push({
                        ...section,
                        branchId: branch.branchId,
                        branchName: branch.branchName
                    });
                });
            }
        });

        // Remove duplicates using utility function
        const uniqueBoards = removeDuplicates(allSelectedBoards, 'boardId');
        const uniqueGrades = removeDuplicates(allSelectedGrades, 'gradeId');

        return {
            academicYear: this.state.selectedAcademicYear,
            selectedBranches: allSelectedBranches,
            selectedBoards: uniqueBoards,
            selectedGrades: uniqueGrades,
            selectedSections: allSelectedSections,
            totalStudents: allSelectedSections.reduce((sum, section) => sum + (section.studentCount || 0), 0),
            branchSelections: this.state.branchSelections,
            // Add summary counts
            summary: {
                branchCount: allSelectedBranches.length,
                boardCount: uniqueBoards.length,
                gradeCount: uniqueGrades.length,
                sectionCount: allSelectedSections.length,
                totalStudents: allSelectedSections.reduce((sum, section) => sum + (section.studentCount || 0), 0)
            }
        };
    }

    // Helper method to check if user has made any previous module selections
    checkUserModuleSelections = (promotionData) => {
        console.log('=== CHECKING FOR EXISTING MODULE SELECTIONS ===');

        // Check if there are existing branch module selections
        const existingSelections = promotionData?.branchModuleSelections || {};
        const hasExistingSelections = Object.keys(existingSelections).length > 0;

        // Check if this is coming from navigation history (user has been to module selection screen before)
        const hasNavigationHistory = promotionData?.navigationHistory &&
            promotionData.navigationHistory.includes('module-selection');

        // Check if there's a timestamp indicating previous modifications
        const hasBeenModified = promotionData?.lastModified || promotionData?.preservedAt;

        // Check if there are explicit module selections in any branch
        let hasExplicitModuleChanges = false;
        if (hasExistingSelections) {
            Object.values(existingSelections).forEach(branchModules => {
                // Check if user has made explicit changes to optional modules
                const optionalModules = ['feeSetup', 'finance'];
                optionalModules.forEach(moduleKey => {
                    if (branchModules.hasOwnProperty(moduleKey)) {
                        hasExplicitModuleChanges = true;
                    }
                });
            });
        }

        console.log('Module Selection Check Results:');
        console.log('  Has existing selections:', hasExistingSelections);
        console.log('  Has navigation history:', hasNavigationHistory);
        console.log('  Has been modified:', !!hasBeenModified);
        console.log('  Has explicit module changes:', hasExplicitModuleChanges);

        const userHasPreviousSelections = hasExistingSelections || hasNavigationHistory || !!hasBeenModified;
        console.log('  🎯 User has previous selections:', userHasPreviousSelections);

        return {
            userHasPreviousSelections,
            hasExistingSelections,
            hasNavigationHistory,
            hasBeenModified: !!hasBeenModified,
            hasExplicitModuleChanges,
            existingSelections
        };
    }

    // Helper method to add default module selections for new branches
    addDefaultModuleSelectionsForNewBranches = (existingModuleSelections, selectedBranches) => {
        console.log('🔧 Adding default module selections for new branches...');

        const updatedModuleSelections = { ...existingModuleSelections };

        // Default modules that should be selected for new branches
        const defaultModules = {
            admissions: true,
            financeGeneralSettings: true,
            feeSetup: true,
            finance: true
        };

        selectedBranches.forEach(branch => {
            const branchId = branch.branchId;

            // If this branch doesn't have existing module selections, add defaults
            if (!updatedModuleSelections[branchId]) {
                console.log(`  📝 Adding default modules for new branch: ${branch.branchName}`);
                updatedModuleSelections[branchId] = { ...defaultModules };
            } else {
                console.log(`  ✅ Branch ${branch.branchName} already has module selections - preserving them`);
            }
        });

        console.log('🔧 Updated module selections:', updatedModuleSelections);
        return updatedModuleSelections;
    }

    handleNext = async () => {
        const selectedData = this.getSelectedData();

        console.log('=== PROMOTION DATA VALIDATION ===');
        console.log('Selected Data Summary:', selectedData.summary);
        console.log('Academic Year:', selectedData.academicYear);
        console.log('Total Selected Branches:', selectedData.selectedBranches.length);
        console.log('Total Selected Sections:', selectedData.selectedSections.length);

        if (!this.validateSelection(selectedData)) {
            console.log('❌ Validation Failed - stopping execution');
            return;
        }

        try {
            this.setState({ isLoading: true });

            console.log('\n=== DETAILED PAYLOAD STRUCTURE ===');

            // Log the complete selected data structure
            console.log('📋 Complete Selected Data:', JSON.stringify(selectedData, null, 2));

            // Log branch selections in detail
            console.log('\n📍 Branch Selections Breakdown:');
            Object.keys(this.state.branchSelections).forEach(branchId => {
                const branchSelection = this.state.branchSelections[branchId];
                const branchInfo = this.state.branchData.find(b => b.branchId === branchId);

                if (branchInfo && branchInfo.selected) {
                    console.log(`\nBranch: ${branchInfo.branchName} (${branchId})`);
                    console.log('  📚 Selected Boards:', branchSelection.boards.map(b => `${b.boardName} (${b.boardId})`));
                    console.log('  📖 Selected Grades:', branchSelection.grades.map(g => `${g.gradeName} (${g.gradeId})`));
                    console.log('  📝 Selected Sections:', branchSelection.sections.map(s => `${s.sectionName} (${s.sectionId}) - ${s.studentCount} students`));
                }
            });

            // Prepare the hierarchical payload structure as required
            const hierarchicalPayload = {
                academicYear: localStorage.getItem('userAcademicYear'),
                targetAcademicYear: selectedData.academicYear,
                orgId: localStorage.getItem('orgId'),
                branches: this.prepareBranchesPayloadForNextScreen()
            };

            console.log('\n=== HIERARCHICAL PAYLOAD (DATA) FOR NEXT SCREEN ===');
            console.log('🎯 Final Payload Structure:', JSON.stringify(hierarchicalPayload, null, 2));

            // Enhanced promotion data for the next screen
            const enhancedPromotionData = {
                ...selectedData,
                fromAcademicYear: hierarchicalPayload.academicYear,
                toAcademicYear: hierarchicalPayload.targetAcademicYear,
                orgId: hierarchicalPayload.orgId,
                data: hierarchicalPayload, // This is the "data" payload with relations
                branchSelections: this.state.branchSelections,
                metadata: {
                    submittedAt: new Date().toISOString(),
                    submittedBy: localStorage.getItem('userId'),
                    totalBranches: selectedData.selectedBranches.length,
                    totalSections: selectedData.selectedSections.length,
                    totalStudents: selectedData.totalStudents
                },
                // Additional context data
                allBranchData: this.state.allBranchData,
                currentUserInfo: {
                    userId: localStorage.getItem('userId'),
                    userName: localStorage.getItem('userName'),
                    userRole: localStorage.getItem('userRole')
                },
                // Preserve any existing module selections or navigation history
                branchModuleSelections: this.state.promotionData?.branchModuleSelections || {},
                navigationHistory: this.state.promotionData?.navigationHistory || [],
                lastModified: this.state.promotionData?.lastModified,
                preservedAt: this.state.promotionData?.preservedAt
            };

            // Check for existing module selections
            const moduleSelectionCheck = this.checkUserModuleSelections(enhancedPromotionData);

            // Add default module selections for new branches
            enhancedPromotionData.branchModuleSelections = this.addDefaultModuleSelectionsForNewBranches(
                enhancedPromotionData.branchModuleSelections,
                selectedData.selectedBranches
            );

            // Add module selection metadata to the enhanced data
            enhancedPromotionData.moduleSelectionMetadata = {
                ...moduleSelectionCheck,
                checkedAt: new Date().toISOString()
            };

            console.log('\n=== MODULE SELECTION STATE CHECK ===');
            console.log('🔍 Module Selection Analysis:', moduleSelectionCheck);

            if (moduleSelectionCheck.userHasPreviousSelections) {
                console.log('✅ User has previous module selections - they will be preserved');
                console.log('📋 Existing selections:', moduleSelectionCheck.existingSelections);
            } else {
                console.log('🆕 New user - will show default module selections (all selected)');
            }

            console.log('\n=== ENHANCED PROMOTION DATA FOR NEXT SCREEN ===');
            console.log('🚀 Enhanced Data with module state check:', JSON.stringify(enhancedPromotionData, null, 2));

            // Move to next step with enhanced data
            this.setState({
                currentTab: 1,
                promotionData: enhancedPromotionData,
                isLoading: false
            });

            console.log('✅ Successfully moved to Module Selection screen');
            this.showSuccess('Moving to module selection');
            // show success message on screen and after process completion 
            // if success then redirect to home screen
            // if not the show error message and move to previous screen


        } catch (error) {
            console.error('❌ Error preparing promotion data:', error);
            console.log('Error Details:', {
                message: error.message,
                stack: error.stack,
                selectedData: selectedData
            });
            this.setState({ isLoading: false });
            this.showError('Error preparing promotion data. Please try again.');
        }
    };

    // Add this helper method to prepare branches payload in the required hierarchical structure
    prepareBranchesPayloadForNextScreen = () => {
        const { branchSelections, allBranchData } = this.state;

        console.log('\n🔄 Preparing hierarchical branches payload...');

        return Object.keys(branchSelections)
            .filter(branchId => {
                const branch = this.state.branchData.find(b => b.branchId === branchId);
                return branch && branch.selected;
            })
            .map(branchId => {
                const branchSelection = branchSelections[branchId];
                const branchInfo = this.state.branchData.find(b => b.branchId === branchId);
                const fullBranchData = allBranchData.find(b => b.branchId === branchId);

                console.log(`\n📍 Processing branch: ${branchInfo.branchName}`);

                // Handle branches with no boards (like "Branch 1" in your example)
                if (!branchSelection.boards || branchSelection.boards.length === 0) {
                    console.log(`  ⚠️ Branch ${branchInfo.branchName} has no boards selected`);
                    return {
                        branchId: branchId,
                        branchName: branchInfo.branchName,
                        boardCount: 0,
                        selected: true,
                        boards: []
                    };
                }

                // Organize boards with their respective grades and sections
                const boardsWithHierarchy = branchSelection.boards.map(selectedBoard => {
                    console.log(`  📚 Processing board: ${selectedBoard.boardName}`);

                    const fullBoardData = fullBranchData?.boards?.find(b => b.boardId === selectedBoard.boardId);

                    // Find grades that belong to this board and are selected
                    const boardGrades = branchSelection.grades.filter(selectedGrade => {
                        return fullBoardData?.grades?.some(g => g.gradeId === selectedGrade.gradeId);
                    });

                    console.log(`    📖 Found ${boardGrades.length} grades for this board`);

                    const gradesWithSections = boardGrades.map(selectedGrade => {
                        console.log(`    📖 Processing grade: ${selectedGrade.gradeName}`);

                        const fullGradeData = fullBoardData?.grades?.find(g => g.gradeId === selectedGrade.gradeId);

                        // Find sections that belong to this grade and are selected
                        const gradeSections = branchSelection.sections.filter(selectedSection => {
                            return fullGradeData?.sections?.some(s => s.sectionId === selectedSection.sectionId);
                        });

                        console.log(`      📝 Found ${gradeSections.length} sections for this grade`);

                        const formattedSections = gradeSections.map(selectedSection => {
                            console.log(`      📝 Processing section: ${selectedSection.sectionName} (${selectedSection.studentCount} students)`);

                            return {
                                sectionId: selectedSection.sectionId,
                                sectionName: selectedSection.sectionName,
                                studentCount: selectedSection.studentCount || 0,
                                selected: true
                            };
                        });

                        return {
                            gradeId: selectedGrade.gradeId,
                            gradeName: selectedGrade.gradeName,
                            sectionCount: formattedSections.length,
                            selected: true,
                            sections: formattedSections
                        };
                    });

                    return {
                        boardId: selectedBoard.boardId,
                        boardName: selectedBoard.boardName,
                        gradeCount: gradesWithSections.length,
                        selected: true,
                        grades: gradesWithSections
                    };
                });

                console.log(`  ✅ Branch ${branchInfo.branchName} processed: ${boardsWithHierarchy.length} boards`);

                return {
                    branchId: branchId,
                    branchName: branchInfo.branchName,
                    boardCount: boardsWithHierarchy.length,
                    selected: true,
                    boards: boardsWithHierarchy
                };
            });
    };

    // ...existing code...

    // Alternative method if you want to use GET with query parameters
    handleNextWithGet = async () => {
        const selectedData = this.getSelectedData();
        if (!this.validateSelection(selectedData)) {
            return;
        }

        try {
            this.setState({ isLoading: true });

            // Prepare query parameters
            const queryParams = new URLSearchParams({
                academicYear: selectedData.academicYear,
                branches: selectedData.selectedBranches.map(b => b.branchId).join(','),
                boards: selectedData.selectedBoards.map(b => b.boardId).join(','),
                grades: selectedData.selectedGrades.map(g => g.gradeId).join(','),
                sections: selectedData.selectedSections.map(s => s.sectionId).join(',')
            });

            console.log('Query parameters:', queryParams.toString());

            // Make GET request
            const url = `${baseUrlAdmin}/promotions/branch-to-sections?${queryParams.toString()}`;
            const response = await this.service.get(url, true);

            if (response.status && response.res?.data) {
                console.log('Server response:', response.res.data);

                // Move to next step
                this.setState({
                    currentTab: 1,
                    promotionData: {
                        ...selectedData,
                        serverData: response.res.data
                    },
                    isLoading: false
                });

                this.showSuccess('Promotion data prepared successfully');
            } else {
                this.setState({ isLoading: false });
                this.showError('Failed to load promotion data');
            }

        } catch (error) {
            console.error('Error loading promotion data:', error);
            this.setState({ isLoading: false });
            this.showError('Error loading promotion data. Please try again.');
        }
    };

    // Method to fetch branch-to-sections data based on target academic year and orgId
    fetchBranchToSectionsData = async (targetAcademicYear = null) => {
        const academicYear = targetAcademicYear || this.state.selectedAcademicYear;

        if (!academicYear) {
            this.showWarn('Please select Target Academic Year first');
            return;
        }

        try {
            this.setState({ isLoading: true });

            // Prepare query parameters with target academic year and orgId
            const queryParams = new URLSearchParams({
                targetAcademicYear: academicYear,
                orgId: localStorage.getItem('orgId')
            });

            console.log('Fetching branch-to-sections data with parameters:', queryParams.toString());

            // Make GET request to the specified URL
            const url = `${baseUrlAdmin}/promotions/branch-to-sections?${queryParams.toString()}`;
            const response = await this.service.get(url, true);

            if (response.status && response.res?.data) {
                console.log('Branch-to-sections API response:', response.res.data);

                // Process the fetched data to identify already promoted sections
                this.processAlreadyPromotedSections(response.res.data);

                this.showSuccess('Branch-to-sections data fetched successfully');
                return response.res.data;
            } else {
                this.showError('Failed to fetch branch-to-sections data');
                return null;
            }

        } catch (error) {
            console.error('Error fetching branch-to-sections data:', error);
            this.showError('Error fetching branch-to-sections data. Please try again.');
            return null;
        } finally {
            this.setState({ isLoading: false });
        }
    };

    // Method to process already promoted sections and update the UI
    processAlreadyPromotedSections = (fetchedData) => {
        if (!fetchedData || !fetchedData.branches) {
            console.log('No fetched data to process');
            return;
        }

        // Create a Set of already promoted section IDs for quick lookup
        const alreadyPromotedSectionIds = new Set();

        fetchedData.branches.forEach(branch => {
            if (branch.boards) {
                branch.boards.forEach(board => {
                    if (board.grades) {
                        board.grades.forEach(grade => {
                            if (grade.sections) {
                                grade.sections.forEach(section => {
                                    alreadyPromotedSectionIds.add(section.sectionId);
                                });
                            }
                        });
                    }
                });
            }
        });

        console.log('Already promoted section IDs:', Array.from(alreadyPromotedSectionIds));

        // Update allBranchData to mark already promoted sections
        const updatedAllBranchData = this.state.allBranchData.map(branch => ({
            ...branch,
            boards: branch.boards?.map(board => ({
                ...board,
                grades: board.grades?.map(grade => ({
                    ...grade,
                    sections: grade.sections?.map(section => ({
                        ...section,
                        isAlreadyPromoted: alreadyPromotedSectionIds.has(section.sectionId),
                        disabled: alreadyPromotedSectionIds.has(section.sectionId)
                    }))
                }))
            }))
        }));

        // Update current view data if sections are being displayed
        let updatedSectionData = [...this.state.sectionData];
        if (updatedSectionData.length > 0) {
            updatedSectionData = updatedSectionData.map(section => ({
                ...section,
                isAlreadyPromoted: alreadyPromotedSectionIds.has(section.sectionId),
                disabled: alreadyPromotedSectionIds.has(section.sectionId),
                selected: alreadyPromotedSectionIds.has(section.sectionId) ? false : section.selected
            }));
        }

        // Store the fetched data for future reference
        this.setState({
            allBranchData: updatedAllBranchData,
            sectionData: updatedSectionData,
            alreadyPromotedData: fetchedData,
            alreadyPromotedSectionIds: Array.from(alreadyPromotedSectionIds)
        });

        console.log('Updated branch data with already promoted sections');
    };

    // Add this method before the render() method

    getCurrentBranchSelectionSummary = () => {
        const { selectedBranch, branchSelections } = this.state;

        if (!selectedBranch || !branchSelections[selectedBranch]) {
            return {
                totalBoards: 0,
                totalGrades: 0,
                totalSections: 0,
                totalStudents: 0
            };
        }

        const branchSelection = branchSelections[selectedBranch];
        const totalStudents = branchSelection.sections.reduce((sum, section) =>
            sum + (section.studentCount || 0), 0
        );

        return {
            totalBoards: branchSelection.boards.length,
            totalGrades: branchSelection.grades.length,
            totalSections: branchSelection.sections.length,
            totalStudents: totalStudents
        };
    };

    onBoardClick = (boardId) => {
        if (this.state.selectedBoard === boardId) return; // Already selected

        this.setState({
            selectedBoard: boardId,
            selectedGrade: null
        });
        this.loadBoardSpecificData(boardId);
    };

    loadBoardSpecificData = (boardId) => {
        if (!this.state.selectedBranch) return;

        const currentBranchId = this.state.selectedBranch;
        const branchSelections = this.state.branchSelections[currentBranchId] || { boards: [], grades: [], sections: [] };
        const branch = this.state.allBranchData.find(b => b.branchId === currentBranchId);
        const board = branch?.boards?.find(b => b.boardId === boardId);

        if (!board) return;

        // Load grades for this specific board
        const gradesData = board.grades?.map(grade => ({
            ...grade,
            selected: branchSelections.grades.some(sg => sg.gradeId === grade.gradeId)
        })) || [];

        this.setState({ gradeData: gradesData, sectionData: [] });

        // If there are selected grades, load their sections
        const selectedGrades = branchSelections.grades.filter(grade =>
            board.grades?.some(bg => bg.gradeId === grade.gradeId)
        );

        if (selectedGrades.length > 0) {
            this.loadSectionsForSelectedGrades(gradesData, selectedGrades, branchSelections);
        }
    };

    onGradeClick = (gradeId) => {
        if (this.state.selectedGrade === gradeId) return; // Already selected

        this.setState({
            selectedGrade: gradeId,
            selectedSection: null
        });
        this.loadGradeSpecificData(gradeId);
    };

    loadGradeSpecificData = (gradeId) => {
        if (!this.state.selectedBranch) return;

        const currentBranchId = this.state.selectedBranch;
        const branchSelections = this.state.branchSelections[currentBranchId] || { boards: [], grades: [], sections: [] };
        const grade = this.state.gradeData.find(g => g.gradeId === gradeId);

        if (!grade) return;

        // Load sections ONLY for this specific grade (not all selected grades)
        const alreadyPromotedSectionIds = this.state.alreadyPromotedSectionIds || [];
        const sectionsData = grade.sections?.map(section => {
            const isAlreadyPromoted = alreadyPromotedSectionIds.includes(section.sectionId);
            return {
                ...section,
                selected: isAlreadyPromoted ? false : branchSelections.sections.some(ss => ss.sectionId === section.sectionId),
                isAlreadyPromoted: isAlreadyPromoted,
                disabled: isAlreadyPromoted
            };
        }) || [];

        this.setState({ sectionData: sectionsData });
    };

    handleCancel = () => {
        // Reset all state to initial values
        this.setState({
            selectedAcademicYear: '',
            branchData: this.state.branchData.map(branch => ({ ...branch, selected: false })),
            boardData: [],
            gradeData: [],
            sectionData: [],
            branchSelections: {},
            selectedBranch: null,
            selectedBoard: null,
            selectedGrade: null,
            currentTab: 0
        });

        this.showWarn('All selections have been cleared');
    };

    handleModuleSelectionNext = (promotionDataWithModules) => {
        console.log('=== MODULE SELECTION COMPLETE - MOVING TO PREVIEW ===');
        console.log('Module selection data:', promotionDataWithModules.branchModuleSelections);

        this.setState({
            currentTab: 2,
            promotionData: promotionDataWithModules
        });
    };

    handleModuleSelectionBack = (preservedPromotionData) => {
        console.log('=== BACK FROM MODULE SELECTION - PRESERVING DATA ===');
        console.log('Preserved module selections:', preservedPromotionData?.branchModuleSelections);

        // Preserve the module selection data when going back to the first screen
        this.setState({
            currentTab: 0,
            promotionData: preservedPromotionData
        });
    };

    handlePreviewBack = () => {
        console.log('=== BACK FROM PREVIEW TO MODULE SELECTION ===');
        this.setState({ currentTab: 1 });
    };

    handlePreviewCancel = () => {
        this.setState({ currentTab: 0 });
    };


    handlePreviewSubmit = async (finalPromotionData) => {
        try {
            this.setState({ isLoading: true });

            // Simulate success without making API call
            // this.showSuccess('Promotion executed successfully!');

            // Reset to initial state after successful promotion
            this.setState({
                currentTab: 0,
                selectedAcademicYear: '',
                branchData: this.state.branchData.map(branch => ({ ...branch, selected: false })),
                boardData: [],
                gradeData: [],
                sectionData: [],
                branchSelections: {},
                selectedBranch: null,
                selectedBoard: null,
                selectedGrade: null,
                promotionData: null,
                isLoading: false
            });

            // Navigate to home screen after successful promotion
            // setTimeout(() => {
            //     this.props.navigate('/');
            // }, 2000);

            // handlePreviewSubmit = async (finalPromotionData) => {
            //     try {
            //         this.setState({ isLoading: true });

            //         const url = `${baseUrlAdmin}/promotions/execute-promotion`;
            //         const response = await this.service.post(url, finalPromotionData, true);

            //         if (response.status && response.res?.data) {
            //             this.showSuccess('Promotion executed successfully!');

            //             // Reset to initial state after successful promotion
            //             this.setState({
            //                 currentTab: 0,
            //                 selectedAcademicYear: '',
            //                 branchData: this.state.branchData.map(branch => ({ ...branch, selected: false })),
            //                 boardData: [],
            //                 gradeData: [],
            //                 sectionData: [],
            //                 branchSelections: {},
            //                 selectedBranch: null,
            //                 selectedBoard: null,
            //                 selectedGrade: null,
            //                 promotionData: null,
            //                 isLoading: false
            //             });

            //             // Navigate to home screen after successful promotion
            //             setTimeout(() => {
            //                 this.props.navigate('/');
            //             }, 2000);
            // } else {
            //     this.setState({ isLoading: false });
            //     this.showError(response.res?.message || 'Failed to execute promotion');
            // }

        } catch (error) {
            console.error('Error executing promotion:', error);
            this.setState({ isLoading: false });
            this.showError('Error executing promotion. Please try again.');
        }
    };

    render() {
        const {
            selectedAcademicYear,
            academicYearOptions,
            branchData,
            boardData,
            gradeData,
            sectionData,
            isLoading,
            isDataLoading,
            selectedBranch,
            selectedBoard,
            selectedGrade,
            currentTab,
            promotionData
        } = this.state;

        if (isLoading) {
            const shimmerStyle = {
                background: 'linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%)',
                backgroundSize: '200% 100%',
                animation: 'shimmer 1.5s infinite',
                borderRadius: '6px'
            };

            const shimmerKeyframes = `
                @keyframes shimmer {
                    0% { background-position: -200% 0; }
                    100% { background-position: 200% 0; }
                }
            `;

            return (
                <div>
                    <style>{shimmerKeyframes}</style>
                    <Toast ref={this.toast} />
                    <div className="ml-3 mr-3">
                        {/* Academic Year Dropdown Shimmer */}
                        <div className="promotion-header ml-4">
                            <div className="field">
                                <div style={{ marginBottom: '8px' }}>
                                    <div style={{
                                        ...shimmerStyle,
                                        width: '160px',
                                        height: '18px'
                                    }}></div>
                                </div>
                                <div style={{
                                    ...shimmerStyle,
                                    width: '400px',
                                    height: '50px',
                                    border: '2px solid #e0e0e0'
                                }}></div>
                            </div>
                        </div>

                        {/* Empty State Shimmer */}
                        <div className="empty-state text-center p-6 mt-6">
                            <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: '40vh' }}>
                                <div style={{
                                    ...shimmerStyle,
                                    width: '60px',
                                    height: '60px',
                                    borderRadius: '8px',
                                    marginBottom: '24px'
                                }}></div>
                                <div style={{
                                    ...shimmerStyle,
                                    width: '300px',
                                    height: '32px',
                                    marginBottom: '16px'
                                }}></div>
                                <div style={{
                                    ...shimmerStyle,
                                    width: '400px',
                                    height: '20px',
                                    marginBottom: '8px'
                                }}></div>
                                <div style={{
                                    ...shimmerStyle,
                                    width: '320px',
                                    height: '20px'
                                }}></div>
                            </div>
                        </div>
                    </div>
                </div>
            );
        }

        // Render module selection screen
        if (currentTab === 2) {
            // Find the label for the selected academic year
            const targetAcademicYear = this.state.selectedAcademicYear;
            const academicYearOptions = this.state.academicYearOptions || [];
            const selectedYearObj = academicYearOptions.find(opt => opt.value === targetAcademicYear);
            const targetAcademicYearName = selectedYearObj ? selectedYearObj.label : targetAcademicYear;
            return (
                <div>
                    <Toast ref={this.toast} />
                    <PromotionPreview
                        promotionData={promotionData}
                        targetAcademicYear={targetAcademicYear}
                        targetAcademicYearName={targetAcademicYearName}
                        onBack={this.handlePreviewBack}
                        onSubmit={this.handlePreviewSubmit}
                        onCancel={this.handlePreviewCancel}
                    />
                </div>
            );
        }

        // Render module selection screen
        if (currentTab === 1) {
            return (
                <div>
                    <Toast ref={this.toast} />
                    <PromotionModuleSelection
                        promotionData={promotionData}
                        academicYearOptions={academicYearOptions}
                        onNext={this.handleModuleSelectionNext}
                        onBack={this.handleModuleSelectionBack}
                        onCancel={() => this.setState({ currentTab: 0 })}
                    />
                </div>
            );
        }

        // Render first screen (existing code)
        const currentBranchSummary = this.getCurrentBranchSelectionSummary();

        return (
            <div>
                <Toast ref={this.toast} />

                <div className="ml-3 mr-3">
                    {/* Academic Year Selection */}
                    <div className="promotion-header ml-4">
                        <div className="field">
                            <ClassetDropdown
                                id="academicYear"
                                label="Target Academic Year"
                                required={true}
                                value={selectedAcademicYear}
                                options={academicYearOptions}
                                onChange={(e) => this.onAcademicYearChange(e.value)}
                                placeholder="Select year"
                                optionLabel="label"
                                optionValue="value"
                            />
                        </div>
                        <p className="text-600 text-sm mt-2 mb-0">
                            {/* Note: Please select the Target Academic Year first to proceed with promotions. */}
                        </p>
                    </div>

                    {isDataLoading ? (
                        <div className="loading-container text-center">
                            <ProgressSpinner />
                            <p>Loading promotion data...</p>
                        </div>
                    ) : selectedAcademicYear ? (
                        <>
                            <div className="promotion-content">
                                <div className="flex col-12" style={{ minWidth: 'max-content' }}>
                                    {/* Branches Column */}
                                    <div className="col-4">
                                        <h4 className="interSemiBold mr-10 pl-3" style={{ color: 'black', fontSize: '24px' }}>
                                            <u>Branches</u>
                                        </h4>
                                        <div className="ma-scroll-vr-smoke" style={{ height: '63vh', minWidth: '250px', overflowY: 'auto' }}>
                                            {branchData.map(branch => (
                                                <div
                                                    key={branch.branchId}
                                                    className={`mx-3 flex flex-column col-10 justify-content-center card cursor-pointer mb-2 h-6rem shadow-2 ${selectedBranch === branch.branchId ? 'promotion-selected-card' : ''
                                                        } ${branch.selected ? 'promotion-checkbox-selected' : ''}`}
                                                    onClick={() => this.onBranchClick(branch.branchId)}
                                                >
                                                    <div className="flex flex-row justify-content-between">
                                                        <div className="flex flex-row justify-content-start align-items-center">
                                                            <div className="mr-3">
                                                                <BranchTowersIcon height={16.5} width={19.5} />
                                                            </div>
                                                            <div>

                                                                <div className="w-full flex justify-content-start">
                                                                    <p className={`interRegular ${selectedBranch === branch.branchId ? 'promotion-selected-text' : ''
                                                                        }`} style={{ fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                                                                        {branch.branchName}
                                                                    </p>
                                                                </div>
                                                                <p className={`promotion-card-subtitle ${selectedBranch === branch.branchId ? 'promotion-selected-subtitle' : ''
                                                                    }`} style={{ margin: 0, fontSize: '14px' }}>
                                                                    {branch.boardCount || 0} Boards
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex align-items-center">
                                                            <Checkbox
                                                                checked={branch.selected}
                                                                disabled={!selectedAcademicYear}
                                                                onChange={(e) => {
                                                                    e.stopPropagation();
                                                                    this.onBranchChange(branch.branchId, e.checked);
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    </div>

                                    {/* Boards Column */}
                                    <div className="col-4 mr-12">
                                        {selectedBranch && <h4 className="interSemiBold mr-12 pl-3" style={{ color: 'black', fontSize: '24px' }}>
                                            <u>Boards</u>
                                        </h4>}
                                        <div className="ma-scroll-vr-smoke" style={{ maxHeight: '63vh', overflowY: 'auto' }}>
                                            {!selectedBranch ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">Click on a branch to view boards</p>
                                                </div>
                                            ) : boardData.length === 0 ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">No boards available for this branch</p>
                                                </div>
                                            ) : (
                                                boardData.map(board => (
                                                    <div
                                                        key={board.boardId}
                                                        className={`mx-3 flex flex-column col-10 justify-content-center card cursor-pointer mb-2 h-6rem shadow-2 ${selectedBoard === board.boardId ? 'promotion-selected-card' : ''
                                                            } ${board.selected ? 'promotion-checkbox-selected' : ''}`}
                                                        onClick={() => this.onBoardClick(board.boardId)}
                                                    // style={{
                                                    //     transition: 'background-color 0.2s ease',
                                                    // }}
                                                    // onMouseEnter={(e) => {
                                                    //     if (selectedBoard !== board.boardId && !board.selected) {
                                                    //         e.target.style.backgroundColor = '#f8f9fa';
                                                    //     }
                                                    // }}
                                                    // onMouseLeave={(e) => {
                                                    //     if (selectedBoard !== board.boardId && !board.selected) {
                                                    //         e.target.style.backgroundColor = '';
                                                    //     }
                                                    // }}
                                                    >
                                                        <div className="flex flex-row justify-content-between">
                                                            <div className="flex flex-row justify-content-start align-items-center">
                                                                <div className="mr-3">
                                                                    {board.boardId == this.state.selectedBoard?.boardId ?
                                                                        <BoardsIconActive height={19.5} width={21.5} /> :
                                                                        <BoardsIconInActive height={19.5} width={21.5} />
                                                                    }
                                                                </div>
                                                                <div>
                                                                    <div className="w-full flex justify-content-start">
                                                                        <p className={`interRegular ${selectedBoard === board.boardId ? 'promotion-selected-text' : ''
                                                                            }`} style={{ fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                                                                            {board.boardName}
                                                                        </p>
                                                                    </div>
                                                                    <p className={`promotion-card-subtitle ${selectedBoard === board.boardId ? 'promotion-selected-subtitle' : ''
                                                                        }`} style={{ margin: 0, fontSize: '14px' }}>
                                                                        {board.gradeCount || 0} Grades
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <Checkbox
                                                                    checked={board.selected}
                                                                    disabled={!this.state.branchData.find(b => b.branchId === this.state.selectedBranch)?.selected}
                                                                    onChange={(e) => {
                                                                        e.stopPropagation();
                                                                        this.onBoardChange(board.boardId, e.checked);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>

                                    {/* Grades Column */}
                                    <div className="col-4 mr-12">
                                        {(selectedBoard && gradeData.length > 0) && <h4 className="interSemiBold mr-12 pl-3" style={{ color: 'black', fontSize: '24px' }}>
                                            <u>Grades</u>
                                        </h4>}
                                        <div className="ma-scroll-vr-smoke" style={{ maxHeight: '63vh', overflowY: 'auto' }}>
                                            {!selectedBranch ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">Select a branch first</p>
                                                </div>
                                            ) : !selectedBoard ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">Click on a board to view grades</p>
                                                </div>
                                            ) : gradeData.length === 0 ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">No grades available for this board</p>
                                                </div>
                                            ) : (
                                                gradeData.map(grade => (
                                                    <div
                                                        key={grade.gradeId}
                                                        className={`mx-3 flex flex-column col-10 justify-content-center card cursor-pointer mb-2 shadow-2 ${selectedGrade === grade.gradeId ? 'promotion-selected-card' : ''
                                                            } ${grade.selected ? 'promotion-checkbox-selected' : ''}`}
                                                        style={{
                                                            minHeight: '80px',
                                                            padding: '16px'
                                                        }}
                                                        onClick={() => this.onGradeClick(grade.gradeId)}
                                                    >
                                                        <div className="flex flex-row justify-content-between align-items-center">
                                                            <div className="flex flex-row justify-content-start align-items-center">
                                                                <div className="mr-3">
                                                                    <GradesIcon height={16.5} width={19.5} />
                                                                </div>
                                                                <div>
                                                                    <div className="w-full flex justify-content-start">
                                                                        <p className={`interRegular ${selectedGrade === grade.gradeId ? 'promotion-selected-text' : ''
                                                                            }`} style={{ fontWeight: 'bold', fontSize: '16px', margin: 0 }}>
                                                                            {grade.gradeName}
                                                                        </p>
                                                                    </div>
                                                                    <p className={`promotion-card-subtitle ${selectedGrade === grade.gradeId ? 'promotion-selected-subtitle' : ''
                                                                        }`} style={{ margin: 0, fontSize: '14px' }}>
                                                                        {grade.sectionCount || 0} Sections
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <Checkbox
                                                                    checked={grade.selected}
                                                                    disabled={!this.state.branchData.find(b => b.branchId === this.state.selectedBranch)?.selected ||
                                                                        !this.state.branchSelections[this.state.selectedBranch]?.boards?.some(board =>
                                                                            this.state.allBranchData.find(br => br.branchId === this.state.selectedBranch)
                                                                                ?.boards?.find(b => b.boardId === board.boardId)
                                                                                ?.grades?.some(g => g.gradeId === grade.gradeId)
                                                                        )}
                                                                    onChange={(e) => {
                                                                        e.stopPropagation();
                                                                        this.onGradeChange(grade.gradeId, e.checked);
                                                                    }}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>

                                    {/* Sections Column */}
                                    <div className="col-4">
                                        {(selectedGrade && sectionData.length > 0) && <h4 className="interSemiBold mr-12 pl-3" style={{ color: 'black', fontSize: '24px' }}>
                                            <u>Sections</u>
                                        </h4>}
                                        <div className="ma-scroll-vr-smoke" style={{ maxHeight: '63vh', overflowY: 'auto' }}>
                                            {!selectedBranch ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">Select a branch first</p>
                                                </div>
                                            ) : !selectedBoard ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">Select a board first</p>
                                                </div>
                                            ) : !selectedGrade ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">Click on a grade to view sections</p>
                                                </div>
                                            ) : sectionData.length === 0 ? (
                                                <div className="empty-state text-center p-4">
                                                    <i className="pi pi-info-circle text-4xl text-400 mb-3"></i>
                                                    <p className="text-600">No sections available for this grade</p>
                                                </div>
                                            ) : (
                                                sectionData.map(section => (
                                                    <div
                                                        key={section.sectionId}
                                                        className={`mx-3 flex flex-column col-10 justify-content-center card mb-2 shadow-2 ${section.isAlreadyPromoted
                                                            ? 'promotion-already-promoted-section'
                                                            : section.selected
                                                                ? 'promotion-checkbox-selected cursor-pointer'
                                                                : 'cursor-pointer'
                                                            }`}
                                                        style={{
                                                            minHeight: '80px',
                                                            padding: '16px',
                                                            opacity: section.isAlreadyPromoted ? 0.5 : 1,
                                                            backgroundColor: section.isAlreadyPromoted ? '#f5f5f5' : '',
                                                            cursor: section.isAlreadyPromoted ? 'not-allowed' : 'pointer'
                                                        }}
                                                    >
                                                        <div className="flex flex-row justify-content-between align-items-center">
                                                            <div className="flex flex-row justify-content-start align-items-center">
                                                                <div className="mr-3">
                                                                    <SectionIcon height={16.5} width={19.5} />
                                                                </div>
                                                                <div>
                                                                    <div className="w-full flex justify-content-start">
                                                                        <p className="interRegular" style={{
                                                                            fontWeight: 'bold',
                                                                            fontSize: '16px',
                                                                            margin: 0,
                                                                            color: section.isAlreadyPromoted ? '#999' : 'inherit'
                                                                        }}>
                                                                            {section.sectionName}
                                                                            {section.isAlreadyPromoted && (
                                                                                <span style={{
                                                                                    fontSize: '12px',
                                                                                    color: '#ff6b6b',
                                                                                    marginLeft: '8px',
                                                                                    fontWeight: 'normal'
                                                                                }}>
                                                                                    (Already Promoted)
                                                                                </span>
                                                                            )}
                                                                        </p>
                                                                    </div>
                                                                    <p className="promotion-card-subtitle" style={{
                                                                        margin: 0,
                                                                        fontSize: '14px',
                                                                        color: section.isAlreadyPromoted ? '#999' : 'inherit'
                                                                    }}>
                                                                        {/* {(section.studentCount !== undefined && section.studentCount !== null) ? section.studentCount : 0} students */}
                                                                    </p>
                                                                </div>
                                                            </div>
                                                            <div className="flex align-items-center">
                                                                <Checkbox
                                                                    checked={section.selected}
                                                                    disabled={
                                                                        section.isAlreadyPromoted ||
                                                                        !this.state.branchData.find(b => b.branchId === this.state.selectedBranch)?.selected ||
                                                                        !this.state.branchSelections[this.state.selectedBranch]?.grades?.some(g => g.gradeId === selectedGrade)
                                                                    }
                                                                    onChange={(e) => this.onSectionChange(section.sectionId, e.checked)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Footer Buttons */}
                            <div className="promotion-footer flex justify-content-center gap-3 mt-6 mb-4 px-4">
                                <Button
                                    label={isLoading ? "Processing..." : "Next"}
                                    icon={isLoading ? "pi pi-spin pi-spinner" : ""}
                                    // iconPos="right"
                                    className="p-button promotion-next-btn"
                                    style={{
                                        borderRadius: '12px',
                                        padding: '12px 24px',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        backgroundColor: (selectedAcademicYear && !isLoading) ? '#3B82F6' : '#9CA3AF',
                                        border: 'none',
                                        color: '#ffffff',
                                        width: '286px',
                                        height: '48px',
                                        cursor: (selectedAcademicYear && !isLoading) ? 'pointer' : 'not-allowed',
                                        transition: 'all 0.3s ease'
                                    }}
                                    onClick={this.handleNext}
                                    disabled={!selectedAcademicYear || isLoading}
                                />
                                <Button
                                    label="Cancel"
                                    // icon="pi pi-times"
                                    className="p-button-outlined promotion-cancel-btn"
                                    style={{
                                        borderRadius: '12px',
                                        padding: '12px 24px',
                                        fontSize: '16px',
                                        fontWeight: '600',
                                        border: '0px solid black',
                                        color: '#6B7280',
                                        backgroundColor: '#F4F5F6',
                                        width: '150px',
                                        height: '48px'
                                    }}
                                    onClick={this.handleCancel}
                                />

                            </div>
                        </>
                    ) : (
                        <div className="empty-state text-center p-6 mt-6">
                            <div className="flex flex-column align-items-center justify-content-center" style={{ minHeight: '40vh' }}>
                                <i className="pi pi-calendar text-6xl text-400 mb-4"></i>
                                <h3 className="text-700 mb-2">Select Target Academic Year</h3>
                                <p className="text-600 text-center mb-0" style={{ maxWidth: '400px' }}>
                                    Please select a target academic year from the dropdown above to view and manage branch promotions.
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

const mapStatesToProps = (state) => ({
    permissionIds: state.currentUserPerms && state.currentUserPerms.permissionIds && state.currentUserPerms.permissionIds,
    userInfo: state.currentUserPerms && state.currentUserPerms.userInfo ? state.currentUserPerms.userInfo : {},
});

export default connect(mapStatesToProps, {})(Authentication(withRouter(Promotions)));